import React, { useState, useRef } from 'react';
import './AnexoUpload.css';

interface AnexoUploadProps {
  onFileSelect: (file: File | null) => void;
  obrigatorio?: boolean;
  label?: string;
  acceptedTypes?: string;
  disabled?: boolean;
}

const AnexoUpload: React.FC<AnexoUploadProps> = ({
  onFileSelect,
  obrigatorio = false,
  label = "Anexar arquivo",
  acceptedTypes = "application/pdf,image/jpeg,image/jpg,image/png",
  disabled = false
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
    onFileSelect(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    onFileSelect(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const getFileIcon = (fileName: string): string => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'ti ti-file-type-pdf';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'ti ti-file-type-jpg';
      default:
        return 'ti ti-file';
    }
  };

  return (
    <div className="anexo-upload">
      <label className="anexo-upload-label">
        {label}
        {obrigatorio && <span className="text-danger">*</span>}
      </label>

      {!selectedFile ? (
        <div className="anexo-upload-area">
          <input
            ref={inputRef}
            type="file"
            onChange={handleFileChange}
            accept={acceptedTypes}
            disabled={disabled}
            className="anexo-upload-input"
            id="anexo-file-input"
          />
          <label htmlFor="anexo-file-input" className="anexo-upload-trigger">
            <i className="ti ti-upload me-2"></i>
            Selecionar arquivo
          </label>
          <small className="text-muted d-block mt-2">
            Formatos aceitos: PDF, JPG, PNG (máx. 10MB)
          </small>
        </div>
      ) : (
        <div className="anexo-upload-preview">
          <div className="file-info">
            <i className={`${getFileIcon(selectedFile.name)} file-icon`}></i>
            <div className="file-details">
              <span className="file-name">{selectedFile.name}</span>
              <span className="file-size">{formatFileSize(selectedFile.size)}</span>
            </div>
          </div>
          <button
            type="button"
            onClick={handleRemoveFile}
            className="btn btn-sm btn-outline-danger"
            disabled={disabled}
          >
            <i className="ti ti-trash"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default AnexoUpload;
